module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/title-result-af6308e286deff0bfae2264f5643ed8d.png";